"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const ro = require("redux-observable");
const projectUsers = require("./projectUsers");
const _current = require("../../modules/customer/current/epics");
const _projects = require("../../modules/project/list/epics");
const current = _current.default('management');
const projects = _projects.default('management');
exports.allEpics = ro.combineEpics(projectUsers.fetch, projectUsers.remove, current.fetch, projects.fetch);
//# sourceMappingURL=index.js.map